import { formatCurrency } from '@airship-platform/airship-patterns';
import { countOptionItems } from '@airship-platform/appointments-feature/utils';
import { FlexBox } from '@airship-platform/jam-web/components';
import Typography from '@mui/material/Typography';
import { useAppointmentProposalOptionProducts } from '../../data-access/appointmentProposalOptionProducts';
import { useAppointmentProposalOptions } from '../../data-access/appointmentProposalOptions';
import { ApplyProposalTemplateOptionsButton } from '../proposal-templates';
import DeletedOptionAlert from './components/DeletedOptionAlert';
import ExpiredProposalAlert from './components/ExpiredProposalAlert';
import ManageOptionSummaryButton from './components/ManageOptionSummaryButton';
import SoldOptionAlert from './components/SoldOptionAlert';

const OptionHeader: React.FC = () => {
  const { currentOption, currentOptionCosts } = useAppointmentProposalOptions();
  const { proposalProducts } = useAppointmentProposalOptionProducts();

  if (!currentOption) {
    return null;
  }

  const isReadOnly = currentOption.isReadOnly;

  const relevantProducts = proposalProducts.filter(
    (product) =>
      product.appointmentProposalOptionId ===
      currentOption.appointmentProposalOptionId
  );

  const hasMembershipProducts = relevantProducts.some(
    (product) => product.hasMembership
  );
  const productsCount = countOptionItems(relevantProducts);
  const optionTotal = currentOptionCosts?.totalWithTax || 0;
  const membershipSavings = currentOptionCosts?.membershipSavings || 0;
  const optionTotalPreMembership = optionTotal + membershipSavings;

  return (
    <FlexBox flexDirection={'column'} gap={2}>
      <SoldOptionAlert option={currentOption} />
      <DeletedOptionAlert option={currentOption} />
      <ExpiredProposalAlert />
      <FlexBox flexDirection={'column'}>
        <Typography variant="h2">{currentOption.name}</Typography>
        {hasMembershipProducts ? (
          <FlexBox flexDirection="row" gap={1} flexWrap="wrap">
            <Typography
              variant="subtitle1"
              sx={{ textDecoration: 'line-through' }}
            >
              {formatCurrency(optionTotalPreMembership)}
            </Typography>
            <Typography variant="subtitle1" color="secondary">
              {formatCurrency(optionTotal)} member price
            </Typography>
            <Typography variant="subtitle1">
              • {productsCount} {productsCount === 1 ? 'item' : 'items'}
            </Typography>
          </FlexBox>
        ) : (
          <Typography variant="subtitle1">
            Total: {formatCurrency(optionTotal)} • {productsCount}{' '}
            {productsCount === 1 ? 'item' : 'items'}
          </Typography>
        )}
      </FlexBox>
      <FlexBox gap={2} flexDirection={['column', 'row']}>
        <ApplyProposalTemplateOptionsButton disabled={isReadOnly} />
        <ManageOptionSummaryButton />
      </FlexBox>
    </FlexBox>
  );
};

export default OptionHeader;
